import { Space as SpaceComponent } from "./Space";

export const Space = Object.assign(SpaceComponent, {
})